import React from 'react';

const About: React.FC = () => {
  return (
    <div className="page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-title">About TRAVEZE</h1>
          <p className="page-subtitle">
            We're passionate about making travel accessible, personalized, and unforgettable for everyone
          </p>
        </div>
      </div>
      
      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Our Story</h2>
              <p>
                Founded in 2020, TRAVEZE was born from a simple belief: everyone deserves to experience the world in their own unique way. Our founders, avid travelers themselves, recognized that traditional travel planning was often overwhelming, time-consuming, and one-size-fits-all.
              </p>
              <p>
                We set out to revolutionize travel planning by combining artificial intelligence with human expertise, creating personalized experiences that match each traveler's unique preferences, budget, and dreams.
              </p>
              <p>
                Today, TRAVEZE has helped over 50,000 travelers discover new destinations, create lasting memories, and explore the world with confidence. Our AI-powered platform continues to evolve, learning from each journey to provide even better recommendations.
              </p>
            </div>
            <div className="story-image">
              <div className="about-image-placeholder"></div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="about-mission">
        <div className="container">
          <div className="mission-grid">
            <div className="mission-card">
              <h3>Our Mission</h3>
              <p>
                To democratize travel by making personalized trip planning accessible to everyone, regardless of experience level or budget. We believe that travel should be inspiring, not intimidating.
              </p>
            </div>
            <div className="mission-card">
              <h3>Our Vision</h3>
              <p>
                To become the world's most trusted travel companion, helping millions of people discover the joy of exploration and create meaningful connections across cultures.
              </p>
            </div>
            <div className="mission-card">
              <h3>Our Values</h3>
              <ul>
                <li>Personalization over generalization</li>
                <li>Authenticity in every recommendation</li>
                <li>Sustainability and responsible travel</li>
                <li>Accessibility for all travelers</li>
                <li>Continuous innovation and improvement</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      <section className="about-team">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Team</h2>
            <p className="section-subtitle">
              Meet the passionate individuals behind TRAVEZE
            </p>
          </div>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-avatar"></div>
              <h4>Sarah Johnson</h4>
              <p className="member-role">CEO & Co-Founder</p>
              <p className="member-bio">
                Former travel industry executive with 15+ years of experience in hospitality and tourism.
              </p>
            </div>
            <div className="team-member">
              <div className="member-avatar"></div>
              <h4>David Chen</h4>
              <p className="member-role">CTO & Co-Founder</p>
              <p className="member-bio">
                AI researcher and software engineer passionate about applying machine learning to travel.
              </p>
            </div>
            <div className="team-member">
              <div className="member-avatar"></div>
              <h4>Maria Rodriguez</h4>
              <p className="member-role">Head of Travel Experience</p>
              <p className="member-bio">
                Travel blogger and cultural anthropologist who has visited over 80 countries.
              </p>
            </div>
            <div className="team-member">
              <div className="member-avatar"></div>
              <h4>James Thompson</h4>
              <p className="member-role">VP of Engineering</p>
              <p className="member-bio">
                Full-stack developer with expertise in scalable systems and user experience design.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="about-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3 className="stat-number">50,000+</h3>
              <p className="stat-label">Happy Travelers</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">150+</h3>
              <p className="stat-label">Countries Covered</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">98%</h3>
              <p className="stat-label">Satisfaction Rate</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">1M+</h3>
              <p className="stat-label">Itineraries Created</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 